import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinmorgaonsupe() {



const cardData =
  {
    keyword: 'Bus On Rent in Morgaon Supe',
    heading: 'Sanavi Travels: Bus On Rent in Morgaon Supe',
    headingDescription: 'Sanavi Travels offers highly reliable, well-organized, and professionally managed Bus On Rent in Morgaon Supe, serving pilgrims, families, senior citizens, corporate groups, schools, wedding parties, picnic travelers, and outstation passengers. Morgaon Supe holds immense religious significance as Morgaon is considered the foremost shrine of the Ashtavinayak pilgrimage, attracting devotees from Pune, Mumbai, Solapur, Ahmednagar, and across Maharashtra throughout the year. Due to heavy pilgrim inflow during Angarki Chaturthi, Ganesh Chaturthi, weekends, and festival days, organized group transportation becomes essential for peaceful darshan and smooth travel management. To fulfill these requirements, we provide a wide fleet of AC buses, Non-AC buses, luxury coaches, mini buses, and high-capacity buses suitable for short religious trips as well as long-distance pilgrimage and outstation journeys. Each bus is meticulously maintained with clean interiors, comfortable cushioned seating, smooth suspension, proper ventilation, and sufficient luggage space for devotees’ belongings and prasad. Our experienced drivers are well-acquainted with Morgaon Supe village roads, Baramati, Daund, Indapur, Pune city routes, and major highways, ensuring safe driving, punctual pickups, and hassle-free navigation even during peak crowd periods. With flexible rental packages, transparent pricing, and 24/7 customer support, Sanavi Travels makes bus rental in Morgaon Supe comfortable, safe, and spiritually fulfilling for every group.',

    top: 'Top Places to Visit Near Morgaon Supe with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shri Mayureshwar Ganpati Temple, Morgaon",
    "description": "Shri Mayureshwar Ganpati Temple at Morgaon is the first and most important temple in the Ashtavinayak circuit, holding immense spiritual value for devotees. Pilgrims believe that an Ashtavinayak yatra is incomplete without darshan at Morgaon. The temple witnesses continuous footfall throughout the year, with massive crowds during Angarki Chaturthi and Ganeshotsav. Bus rentals are the most preferred option for group darshan, senior citizen tours, bhajan mandals, and family pilgrimages, ensuring safe, organized, and peaceful travel."
  },
  {
    "title": "Supe Village Area",
    "description": "Supe is a developing rural area close to Morgaon, supporting pilgrimage traffic with lodging, food facilities, and village connectivity. Many devotees stay in or pass through Supe while visiting Morgaon Ganpati. Bus hire services help manage smooth transportation between Supe, Morgaon temple, and surrounding villages without time pressure or parking issues."
  },
  {
    "title": "Baramati Connectivity",
    "description": "Baramati serves as a major town near Morgaon Supe, offering road connectivity, accommodation, and market facilities for pilgrims. Many Ashtavinayak tour buses pass through Baramati. Hiring a bus ensures smooth travel coordination, rest stops, and timely arrival for darshan schedules."
  },
  {
    "title": "Ashtavinayak Pilgrimage Circuit",
    "description": "Morgaon is a key destination in the Ashtavinayak pilgrimage, often visited along with Siddhatek, Theur, Ranjangaon, and Ozar. Bus rentals are ideal for completing the Ashtavinayak circuit in a systematic and comfortable manner, especially for large devotional groups."
  },
  {
    "title": "Indapur and Daund Routes",
    "description": "The Indapur and Daund routes provide vital access to Morgaon Supe for pilgrims traveling from Solapur, Pune, and Ahmednagar sides. Group travel via buses ensures safety, punctuality, and comfort across rural and highway roads."
  },
  {
    "title": "Pune–Baramati Road Access",
    "description": "The Pune–Baramati road offers smooth connectivity to Morgaon Supe, making it convenient for long-distance pilgrims. Bus hire services help reduce travel fatigue and manage large groups efficiently on this busy route."
  },
  {
    "title": "Temple Festival Travel",
    "description": "During Ganesh Chaturthi, Angarki days, and temple fairs, Morgaon experiences extremely high pilgrim traffic. Buses become the safest and most practical mode of transport during such times, ensuring group discipline and hassle-free travel."
  },
  {
    "title": "Senior Citizen Pilgrimage Tours",
    "description": "Senior citizen groups frequently visit Morgaon Supe for darshan. Bus rentals provide easy boarding, comfortable seating, and smooth rides, making spiritual travel convenient and safe for elderly devotees."
  },
  {
    "title": "Bhajan Mandal and Spiritual Group Tours",
    "description": "Bhajan mandals and spiritual organizations regularly organize group visits to Morgaon. Bus hire services help these groups travel together while maintaining schedule discipline and safety."
  },
  {
    "title": "Outstation Devotional Travel",
    "description": "Devotees from Pune, Mumbai, Solapur, Satara, and Ahmednagar frequently travel to Morgaon Supe. Outstation bus rentals ensure smooth long-distance travel with proper rest breaks and comfortable seating."
  }
]
,



"services": [
{
"name": "Bus On Rent in Morgaon Supe",
"description": "Bus On Rent in Morgaon Supe offers safe, comfortable, and professionally managed transportation for pilgrimage groups, families, and spiritual organizations. This service is ideal for Morgaon Ganpati darshan, Ashtavinayak tours, senior citizen pilgrimages, festival travel, and outstation devotional trips. Our buses feature clean interiors, cushioned seating, smooth suspension, proper ventilation, and sufficient luggage space for devotees’ belongings and prasad. Experienced drivers ensure disciplined driving, timely pickups, and smooth navigation through village roads and highways, making the entire journey peaceful and stress-free."
},
{
"name": "Bus Hire Morgaon Supe",
"description": "Bus Hire Morgaon Supe provides flexible rental solutions for one-day darshan trips, overnight pilgrimages, and multi-temple spiritual tours. With reliable vehicles and professional drivers, group travel becomes organized and comfortable."
},
{
"name": "AC Bus Rental Morgaon Supe",
"description": "AC Bus Rental Morgaon Supe is ideal for summer pilgrimages and long journeys, offering air-conditioned comfort, relaxed seating, and reduced travel fatigue for devotees."
},
{
"name": "Non AC Bus on Rent Morgaon Supe",
"description": "Non AC Bus on Rent Morgaon Supe offers economical transportation for short pilgrimage routes, rural temple visits, and budget-friendly group travel without compromising safety."
},
{
"name": "Luxury Bus on Rent Morgaon Supe",
"description": "Luxury Bus on Rent Morgaon Supe delivers premium travel with modern interiors, superior seating, and enhanced ride comfort, suitable for VIP devotees and special spiritual tours."
},
{
"name": "Mini Bus Hire Morgaon Supe",
"description": "Mini Bus Hire Morgaon Supe is perfect for small to medium-sized pilgrimage groups, families, and bhajan mandals, offering flexibility and cost efficiency."
},
{
"name": "32 Seater Bus on Rent Morgaon Supe",
"description": "32 Seater Bus on Rent Morgaon Supe supports medium-sized darshan groups with balanced seating capacity, comfort, and safety."
},
{
"name": "35 Seater Bus Hire Morgaon Supe",
"description": "35 Seater Bus Hire Morgaon Supe is ideal for large pilgrimage groups, festival travel, and Ashtavinayak tours, ensuring organized seating and smooth travel."
},
{
"name": "Bus on Rent Morgaon Supe for Wedding",
"description": "Bus on Rent Morgaon Supe for Wedding supports wedding parties visiting the temple for blessings, ensuring coordinated and punctual guest transportation."
},
{
"name": "Bus on Rent Morgaon Supe for Corporate",
"description": "Bus on Rent Morgaon Supe for Corporate caters to corporate spiritual outings, employee pilgrimage programs, and group retreats with professional service."
},
{
"name": "Bus on Rent Morgaon Supe for Picnic",
"description": "Bus on Rent Morgaon Supe for Picnic provides safe and comfortable group travel for family outings and leisure trips combined with temple visits."
},
{
"name": "Bus Rental Morgaon Supe Outstation",
"description": "Bus Rental Morgaon Supe Outstation offers dependable long-distance transportation from Pune, Mumbai, Solapur, and nearby cities with comfort and safety."
},
{
"name": "Bus Hire Morgaon Supe with Driver",
"description": "Bus Hire Morgaon Supe with Driver provides chauffeur-driven buses where experienced drivers manage routes, traffic, and timing, allowing devotees to focus on worship."
},
{
"name": "Affordable Bus Rental Morgaon Supe",
"description": "Affordable Bus Rental Morgaon Supe delivers cost-effective pilgrimage transport without compromising cleanliness, safety, or reliability."
},
{
"name": "Best Bus Service Morgaon Supe",
"description": "Best Bus Service Morgaon Supe is trusted for punctual service, clean buses, disciplined drivers, and transparent pricing provided by Sanavi Travels."
}
],
"tableData": [
["Bus On Rent in Morgaon Supe", "Bus Hire Morgaon Supe"],
["AC Bus Rental Morgaon Supe", "Non AC Bus Hire Morgaon Supe"],
["Luxury Bus Morgaon Supe", "Mini Bus Hire Morgaon Supe"],
["32 Seater Bus Morgaon Supe", "35 Seater Bus Morgaon Supe"],
["Wedding Bus Morgaon Supe", "Corporate Bus Morgaon Supe"],
["Picnic Bus Morgaon Supe", "Outstation Bus Morgaon Supe"],
["Bus Hire Morgaon Supe with Driver", "Affordable Bus Rental Morgaon Supe"],
["Best Bus Service Morgaon Supe", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Bus On Rent in Morgaon Supe with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels specializes in pilgrimage-focused bus rental services in Morgaon Supe."
  },
  {
    "WhyChooseheading": "Pilgrim-Friendly Buses",
    "WhyChoosedescription": "Comfortable seating and smooth rides suitable for senior citizens and families."
  },
  {
    "WhyChooseheading": "Experienced Temple Route Drivers",
    "WhyChoosedescription": "Drivers are familiar with Morgaon routes, festival traffic, and darshan schedules."
  },
  {
    "WhyChooseheading": "Transparent Pricing",
    "WhyChoosedescription": "Clear pricing with no hidden charges for pilgrimage groups."
  },
  {
    "WhyChooseheading": "24/7 Support",
    "WhyChoosedescription": "Round-the-clock assistance for darshan planning and travel support."
  },
  {
    "WhyChooseheading": "Flexible Pilgrimage Packages",
    "WhyChoosedescription": "One-day, overnight, and Ashtavinayak tour packages available."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "Buses are sanitized before every pilgrimage journey."
  },
  {
    "WhyChooseheading": "On-Time Darshan Travel",
    "WhyChoosedescription": "Punctual pickups ensure stress-free temple visits."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental for Morgaon Ganpati darshan?',
    answer: 'Yes, Sanavi Travels offers dedicated bus rental services for Morgaon Ganpati darshan.'
  },
  {
    question: 'Is bus hire available for Ashtavinayak tours?',
    answer: 'Yes, we provide buses for complete Ashtavinayak pilgrimage tours.'
  },
  {
    question: 'Are buses suitable for senior citizens?',
    answer: 'Yes, our buses offer comfortable seating and smooth rides ideal for senior citizens.'
  },
  {
    question: 'Can I book a bus from Pune or Mumbai to Morgaon Supe?',
    answer: 'Yes, outstation bus rentals from Pune, Mumbai, and nearby cities are available.'
  },
  {
    question: 'Are the buses sanitized?',
    answer: 'Yes, all buses are sanitized before every journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ashok Joshi',
    feedback: 'We hired a bus for Morgaon Ganpati darshan. Very disciplined and peaceful journey.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Sunita Kulkarni',
    feedback: 'Excellent service for our Ashtavinayak tour. Clean bus and very courteous driver.',
    rating: 5
  }
];


















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus On Rent in Morgaon Supe - Sanavi Travels",
  "description": "Sanavi Travels offers bus on rent in Morgaon Supe for weddings, corporate travel, picnics, and outstation trips. We provide AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};




  return (
    <div>


<Helmet>
  <title>
    Call : +91 7387507373 | Bus On Rent in Morgaon Supe | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus on rent in Morgaon Supe with Sanavi Travels. AC & Non-AC buses, luxury and mini bus rental for weddings, corporate travel, picnics, and outstation trips with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/229.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Busonrentinmorgaonsupe;